<template>
	<div class="fast-dashboard-player-list">
		<div class="fast-dashboard-player-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">FDP（Fast Dashboard Player）</span>
			</div>

			<div class="list">
				<ul class="tt">
					<li><img :src="solution_image_01" alt="Xhorse"/></li>
					<li><img :src="solution_image_02" alt="Xhorse"/></li>
				</ul>


				<div class="dd">
					<p>
						Xhorse FDP system is applied to the visual management of factories. It can quickly integrate various information, present financial, business, production, quality, human resources and other related operation and management information in an intuitive and highly interactive way. It can also be combined with mobile devices to provide a new human-computer interaction interface to help senior managers make correct and comprehensive management decisions quickly.</p>
					<p>
						In the factory environment, all kinds of information are transmitted to the display screen through the industrial Internet, and the display configuration is quickly set in the background by means of web interface. The display information can be adjusted and uploaded in the factory site, main control room, remote intelligent terminal and other areas, so as to provide on-site visual management solution.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_intellgent_05.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_intellgent_06.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
            };
        }
    }

</script>

<style scoped="">
	.dd > p:first-child {
		margin-bottom: 1.375rem;
	}

	.dd > p {
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.75rem;
	}

	.dd {
		width: 100%;
		height: 17.5rem;
		margin-top: 2.75rem;
	}

	.tt img {
		width: 100%;
		height: 100%;
	}

	.tt > li:nth-child(1) {
		width: 29.75rem;
	}

	.tt > li:nth-child(2) {
		width: calc(100% - 29.75rem - 1.5rem);
		margin-left: 1.5rem;
	}

	.tt > li {
		height: 20rem;
		float: left;
	}

	.tt {
		height: 20rem;
	}

	.tt, .dd {
		width: 100%;
	}

	.fast-dashboard-player-con {
		width: 61.6rem;
		border: none;
		margin-left: 0;
	}

	.fast-dashboard-player-list {
		width: 61.5rem;
		height: 46.25rem;
		border: none;
	}

	.list {
		width: 54.5rem;
		border: none;
		margin-left: 7rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-fast-dashboard-palyer.vue